'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initializePubSub = exports.pubSubReady = exports.initializePubSubFailed = exports.initializePubSubStarted = exports.initializePubSubSucceeded = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _actionTypes = require('../constants/actionTypes');

var noop = function noop() {};

var initializePubSubSucceeded = exports.initializePubSubSucceeded = function initializePubSubSucceeded(client) {
  return {
    type: _actionTypes.INITIALIZE_PUBSUB.SUCCEEDED,
    payload: { client: client }
  };
};

var initializePubSubStarted = exports.initializePubSubStarted = function initializePubSubStarted() {
  return {
    type: _actionTypes.INITIALIZE_PUBSUB.STARTED
  };
};

var initializePubSubFailed = exports.initializePubSubFailed = function initializePubSubFailed(error) {
  return {
    type: _actionTypes.INITIALIZE_PUBSUB.FAILED,
    payload: { error: error }
  };
};

var pubSubReady = exports.pubSubReady = function pubSubReady() {
  return {
    type: _actionTypes.PUBSUB_READY
  };
};

var initializePubSub = exports.initializePubSub = function initializePubSub(_ref) {
  var clientOptions = _ref.clientOptions,
      _ref$lifecycleHooks = _ref.lifecycleHooks,
      lifecycleHooks = _ref$lifecycleHooks === undefined ? { onConnect: noop, onDisconnect: noop, onFailure: noop } : _ref$lifecycleHooks,
      resolveBuilder = _ref.resolveBuilder;
  return function (dispatch) {
    dispatch(initializePubSubStarted());

    return resolveBuilder().then(function (_ref2) {
      var buildConversationsPubSub = _ref2.buildConversationsPubSub;

      var client = buildConversationsPubSub({
        clientOptions: clientOptions,
        lifecycleHooks: _extends({}, lifecycleHooks, {
          onConnect: function onConnect() {
            dispatch(pubSubReady());
            lifecycleHooks.onConnect.apply(lifecycleHooks, arguments);
          }
        })
      });

      dispatch(initializePubSubSucceeded(client));

      client.connect().catch(function () {
        return lifecycleHooks.onDisconnect();
      });
    }, function (error) {
      dispatch(initializePubSubFailed(error));
      throw error;
    });
  };
};